import type { RefObject } from 'react';

import type { MarketAppWithTabs, WidgetV2 } from '@/features/dashboard/types';
import type { BaseTabType } from '@/features/markets';

// ============================================================================
// Drag-Drop Types
// ============================================================================

export interface DragNode {
  id?: string;
  type?: string;
  group?: string;
  data?: Record<string, unknown>;
  /** Projected sortable index (updated by OptimisticSortingPlugin during drag). */
  index?: number;
  /** Original index at drag start. */
  initialIndex?: number;
}

// ============================================================================
// Component Props Types
// ============================================================================

export interface ItemProps {
  index: number;
  item: WidgetV2;
  column: string;
  onRemoveItem: (id: string) => void;
  onEdit: (tabId: string) => void;
  container: RefObject<HTMLDivElement | null>;
  isSingleItem: boolean;
  currentDashboardName: string;
  currentTabId: string;
  onTabCreated?: (tabName: string, tabId: string) => void;
  onRename: (name: string) => void;
}

export interface ColumnProps {
  id: string;
  index: number;
  items: WidgetV2[];
  onRemoveApp: (id: string) => void;
  onRemoveItem: (id: string) => void;
  container: RefObject<HTMLDivElement | null>;
  currentDashboardName: string;
  currentTabId: string;
  app: MarketAppWithTabs;
  onTabCreated?: (tabName: string, tabId: string) => void;
  preview?: AppsOrderPreview | null;
  isDragging?: boolean;
}

export interface AppsOrderProps {
  onTabCreated?: (tabName: string, tabId: string) => void;
  preview?: AppsOrderPreview | null;
}

// ============================================================================
// Preview Types
// ============================================================================

export interface AppsOrderPreview {
  components?: Array<{
    tabs?: BaseTabType[];
  }>;
}

// ============================================================================
// Constants
// ============================================================================

export const BLANK_COLUMN_ID = '__blank__';
